import React, { useEffect, useMemo, useState } from "react";
import CreatePurchaseOrder from "../../Pages/PurchaseOrder/CreatePurchaseOrder";
import AssignSupplierToItemModal from "../Supplier/AssignSupplierToItem";
import CreateSupplierModal from "../Supplier/CreateSupplier";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";

const CreatePurchaseOrderModal = ({ row }) => {
    const [currentItem, setCurrentItem] = useState(null);
    console.log(row);
    const { useFetch } = useAPIQuery({
        key: "supplier-item",
        endpoint: "/api/supplier-item-association/",
    });
    const { data: supplierItemData, refetch } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    const closeModal = () => {
        const closeBtn = document.getElementById("po_modal_close_btn");
        closeBtn.click();
    };
    const suppliers = useMemo(() => {
        // setModalCurrentItem?.(currentItem);
        if (currentItem && supplierItemData) {
            return supplierItemData?.results?.data
                ?.filter((si) => si?.item?.id === currentItem?.id)
                .map((si) => ({
                    ...si,
                    value: si?.supplier?.id,
                    label:
                        si?.supplier?.user?.first_name +
                        " " +
                        si?.supplier?.user?.last_name,
                }));
        }
    }, [currentItem, supplierItemData]);
    useEffect(() => {
        if (row) {
            setCurrentItem(row);
        }
    }, [row]);
    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);
    return (
        <>
            <div
                className="modal fade m-0 p-0"
                tabIndex={-1}
                id={`create-po-modal`}
                aria-modal
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <button
                            className="close"
                            data-bs-dismiss="modal"
                            id="po_modal_close_btn"
                        >
                            <em
                                className="icon ni ni-cross"
                                aria-hidden="true"
                            ></em>
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">Purchase Order</h5>
                        </div>
                        <div className="modal-body">
                            <CreatePurchaseOrder
                                modal={true}
                                modalCurrentItem={currentItem}
                                setModalCurrentItem={setCurrentItem}
                                closeModal={closeModal}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <AssignSupplierToItemModal
                modal={true}
                currentItem={currentItem}
                suppliers={suppliers}
            />
            <CreateSupplierModal
                modal={true}
                goback={true}
                currentItem={currentItem}
                refetchSuppliers={refetch}
            />
        </>
    );
};

export default CreatePurchaseOrderModal;
